export default __webpack_public_path__ + "static/media/client-timeline-banner.b00d9601.svg";